module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAATxJREFUOE+tkz1Lw2AQx/93LagfQFwc8uDQsYKTg9h28ws4SQ0FW3HTL9LJtwgi6uQXcEtaHJwU3VpBmsGl+AFUiHeS1EKMIYXos93dcz/u7U9IvJuGKX8KmhDUAFjfYR8Mt8BwVk4Hj/EUGhuebU2zoq1hMhEnwZGtKsRwhk/B3vrty1voigBXy/Mzc6XitQqtpiYmnMTaHfaDtRASAbwN64iYWsnkyvkginfqRpMxFT2uXvrb5DZMuRDoveJ32VkAgoowlqhrm30V7KSVngWI+mcckFc3PQJKeQAK9Kmzad6hmMoDAOHj74CsFiatNGoha4iTAIAekmdbiyy4y73GvIcEVady4bf+55THephdKLaZsZXWzkg4KiI4eX0Odn+IKT6scCYaoElMNaKRnFXhE9RVhlM98x/i/78AVoGmNpyoxuMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tipR.png
// module id = 34
// module chunks = 0